<template>
  <div class="mt-3">
    <div class="row mt-3 note-list-container">
      <div
        v-if="notes.length === 0"
        class="col-md-12 mb-2"
      >
        <small>No notes to show</small>
      </div>
      <div
        v-for="(note, index) in reversedNotes"
        :key="index"
        class="note-list"
      >
        <div class="col-md-12 content-list mb-2">
          <b>Note:</b>
          <span>{{ note.content }}</span>
        </div>
        <div class="col-md-12 content-list mb-2">
          <b>Created On:</b>
          <span>{{ note.createdOn | formatDate }}</span>
        </div>
        <div class="col-md-12 content-list">
          <b>Created By:</b>
          <span>{{ note.createdByUserName }}</span>
        </div>
      </div>
    </div>
    <form v-if="userCanEditBookingNotes">
      <div class="row">
        <div class="col-12">
          <label>Add Note</label>
          <textarea
            v-model="note"
            :class="{ 'is-invalid': $v.note.$invalid && $v.note.$dirty }"
            type="text"
            class="form-control full-width"
            placeholder="Enter note..."
            @input="$v.note.$touch()"
          />
        </div>

        <div class="col-12 text-right mt-3">
          <button
            :disabled="$v.note.$invalid"
            type="button"
            class="btn btn-primary ml-2"
            @click="addNote"
          >
            Add note
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
    name: 'Notes',
    props: ['editMode'],
    data () {
        return {
            note: null
        }
    },
    computed: {
        ...mapState({
            notes: state => state.booking.notes,
            bookingDetail: state => state.booking.bookingDetail
        }),
        ...mapGetters({ userCanEditBookingNotes: 'auth/userCanEditBookingNotes' }),
        reversedNotes () {
            return _.reverse(this.notes)
        }
    },
    validations: {
        note: {
            required,
            maxLength: maxLength(160)
        }
    },
    created: function () {
        this.$store.dispatch('getNotes', this.$route.params.bookingId)
    },
    methods: {
        async addNote () {
            var newNote = {
                content: this.note,
                createdOn: new Date()
            }

            await this.$store.dispatch('addNote', [
                this.$route.params.bookingId,
                newNote
            ])
            this.$toasted.success('Note added')
            this.note = null
            this.$store.dispatch('getNotes', this.$route.params.bookingId)
        }
    }
}
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
